<template>
    <div class="cbs-booking-confirmation">
        <div class="success">
            <div class="icon">
                <svg width="84px" height="84px" viewBox="0 0 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                    <circle class="border" cx="42" cy="42" r="40" stroke-linecap="round" stroke-width="4" stroke="#000" fill="none"></circle>
                    <path class="checkmark" stroke-linecap="round" stroke-linejoin="round" d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338"
                          stroke-width="4" stroke="#000" fill="none">
                    </path>
                </svg>
            </div>

            <h3 class="title" data-tid="elements_examples.success.title">
                Your booking is confirmed.
                Thank you for using our services!
            </h3>
            <p class="message">
                <span data-tid="elements_examples.success.message">
                    You will receive a confirmation email shortly with your booking details.
                </span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BookingConfirmation",
        components: {},
        computed: {
            isBookingConfirmed: function () {
                return this.$store.state.bookingInfo.payment.done;
            }
        },
        methods: {}
    }
</script>

<style>
    .cbs-booking-confirmation {
        text-align: center;
        background-color: #fff;
        padding: 50px;
    }

        .cbs-booking-confirmation .success .icon .border {
            stroke: #abe9d2;
        }

        .cbs-booking-confirmation .success .icon .checkmark {
            stroke: #24b47e;
        }

        .cbs-booking-confirmation .success .title {
            margin-top: 45px;
            margin-bottom: 5px;
            color: #32325d;
            font-size: 16px !important;
        }

        .cbs-booking-confirmation .success .message {
            color: #8898aa;
            font-size: 13px !important;
        }
</style>